import React, { Dispatch, FC, SetStateAction } from 'react'
import PulseLoader from 'react-spinners/PulseLoader';

interface PulseLoaderProps {
  showLoader: boolean
  handleClose?: Dispatch<SetStateAction<boolean>>
  loaderText?: string,
  size?:number
}

const CustomPulseLoader: FC<PulseLoaderProps> = (props) => {

  const { showLoader,size} = props;

  return (
    <PulseLoader
      margin={1} // gap between circles 
      speedMultiplier={1}
      size={size?size:12}
      color={'var(--secondary-blue-color)'}
      loading={showLoader}
    />
  )
}

export default CustomPulseLoader